import React from 'react';
import ReactDOM from 'react-dom';


import Home from './containers/Home';
import Login from './containers/Login';

import {Route, Router} from 'react-router'

import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import theme from './assets/react-toolbox/theme.js';

import './assets/react-toolbox/theme.css';
import './public/css/custom.css';
import './public/css/overrides.css';
import * as routes from "./constants/routes";
import Logout from "./containers/Logout";
//import {Provider} from "react-redux";
import client from "./graphql/client";
import {ApolloProvider} from "react-apollo";
import Container from "./containers/Container";
import { history, store } from "./constants/common";


ReactDOM.render(
    <ApolloProvider store={store} client={client}>
        <ThemeProvider theme={theme}>

            <Router history={history}>
                <Route path={routes.LOGIN} component={Login} />
                <Route path={routes.HOME} component={Container} outlet={Home} />
                <Route path={routes.LOGOUT} component={Container} outlet={Logout} />
            </Router>

        </ThemeProvider>
    </ApolloProvider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js